import { render, staticRenderFns } from "./GreenPartVillage.vue?vue&type=template&id=e6b5e088"
import script from "./GreenPartVillage.vue?vue&type=script&lang=ts"
export * from "./GreenPartVillage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports